import { css } from '@emotion/css';

import { m } from '../../motif/m';

export const statsContainerCss = css`
  display: flex;
  flex-direction: column;
  gap: ${m('--spacing-xs')};
  justify-content: center;
  align-items: center;
`;

export const statCss = css`
  font-family: ${m('--h1-font-family')};
  font-stretch: condensed;
  color: ${m('--stats-stat-color')};
  font-weight: ${m('--stats-stat-font-weight')};
  font-size: ${m('--stats-stat-font-size')};
  line-height: ${m('--stats-stat-font-line-height')};
`;
